import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay, take } from 'rxjs/operators';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { FeatureToggleEnum } from '~shared/constants';
import { cdnPath, akamaiPath } from '~shared/constants/sources.config';

@Injectable({
  providedIn: 'root',
})
export class EnergyLabelService {
  private isNewEnergyLabelEnabled$: Observable<boolean>;
  private isAkamaiForEccEnabled = false;

  constructor(private activeFeaturesConfigcatService: ActiveFeaturesConfigcatService) {
    this.isNewEnergyLabelEnabled$ = this.activeFeaturesConfigcatService
      .isFeatureEnabled(FeatureToggleEnum.FF_NEW_ENERGY_LABEL)
      .pipe(shareReplay(1));

    this.activeFeaturesConfigcatService
      .isFeatureEnabled(FeatureToggleEnum.FF_AKAMAI_FOR_ECC_LABELS_ANGULAR)
      .pipe(take(1))
      .subscribe((enabled) => {
        this.isAkamaiForEccEnabled = enabled;
      });
  }

  isNewEnergyLabelEnabled(): Observable<boolean> {
    return this.isNewEnergyLabelEnabled$;
  }

  private getBaseUrl(): string {
    return this.isAkamaiForEccEnabled ? akamaiPath() : `${cdnPath()}/images`;
  }

  getGenericImageUrl(isNewEnergyLabelEnabled: boolean): string {
    const folderName = isNewEnergyLabelEnabled ? 'eec-labels' : 'energy-efficiency-labels';
    return `${this.getBaseUrl()}/${folderName}/generic.svg`;
  }

  getEnergyLabelUrl(
    isNewEnergyLabelEnabled: boolean,
    max: string,
    min: string,
    energyClass: string
  ): string {
    const folderName = isNewEnergyLabelEnabled ? 'eec-labels' : 'energy-efficiency-labels';
    const bucketFolder = isNewEnergyLabelEnabled ? `${max}_to_${min}` : `${max}-${min}`;
    return `${this.getBaseUrl()}/${folderName}/${bucketFolder}/${energyClass}.svg`;
  }
}
